import { FC } from "react";
import { Helmet } from "react-helmet";
import { routes } from "~/constants";
import { canonical } from "~/utils/canonical";

const text = {
  pageTitle: "Payment Details",
};

export const Meta: FC = () => {
  return (
    <Helmet>
      <title itemProp="name" lang="en">
        {text.pageTitle}
      </title>
      {canonical(routes.planPayment)}
    </Helmet>
  );
};
